export default __webpack_public_path__ + "static/media/RESULT.b1b232cc.png";